import {AfterViewInit, Component, Inject, OnInit, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {DIALOG_CONFIG} from 'ac-infra';

@Component({
  selector: 'ntp-dialog',
  templateUrl: './ntp-dialog.component.html',
  styleUrls: ['./ntp-dialog.component.scss']
})
export class NtpDialogComponent implements OnInit, AfterViewInit {

  data;
  @ViewChild('mapForm') mapForm: NgForm;
  conf;

  constructor(@Inject(DIALOG_CONFIG) private dialogConfig) {
    this.data = dialogConfig.dialogData;
    this.conf = dialogConfig;
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.mapForm.form.statusChanges.subscribe(() => {
      this.conf.submitButtonDisabled = !this.mapForm.form.valid;
    });

  }
}
